import React, { ReactNode, useContext } from "react"
import { Route, RouteProps, Redirect } from "react-router-dom"
import AuthContext from "../../context/AuthContext"

type Props = {
    children: ReactNode
}

function AdminRoute({ children, ...routeProps }: Props & RouteProps) {
    const auth = useContext(AuthContext)

    return (
        <Route
            {...routeProps}
            render={({ location }) =>
                auth?.role === "admin" ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: `/organization/products`,
                            state: { from: location },
                        }}
                    />
                )
            }
        />
    )
}

export default AdminRoute
